@for (language of languages(); track language) {
  <atlas-language-list-item
    class="atlas-navbar__language-list-item"
    [language]="language"
    (languageSelected)="selectLanguage($event)"
  ></atlas-language-list-item>
}
